<div class="m-cutoffEditor">
  <div class="m-cutoffEditor__header">
    <div class="m-cutoffEditor__titleWrapper">
      <h4 class="m-cutoffEditor__title">{{ 'NEXPE.CUTOFF.TITLE' | translate }}</h4>
      <button
        type="button"
        class="m-cutoffEditor__infoBtn"
        [attr.title]="'NEXPE.CUTOFF.INFO' | translate"
      >
        ℹ️
      </button>
    </div>
    <button type="button" class="m-cutoffEditor__addBtn" (click)="addTimeSlot()">
      {{ 'NEXPE.CUTOFF.ADD_SLOT' | translate }}
    </button>
  </div>

  <div class="m-cutoffEditor__slots">
    @for (slot of timeSlots(); track $index) {
    <app-timeslot-row
      [timeSlot]="slot"
      [index]="$index"
      (timeSlotChange)="onTimeSlotChange($event)"
      (deleteSlot)="onDeleteSlot($event)"
    />
    } @empty {
    <p class="m-cutoffEditor__empty">{{ 'NEXPE.CUTOFF.NO_SLOTS' | translate }}</p>
    }
  </div>
</div>
